import * as React from 'react';

import { Row as AntdRow, Col, Divider } from 'antd';
import { Row, Text, Space } from 'farmhub-ui-core';

import { useAppSelector } from 'app';
import {
  CertificationSelected,
  CheckFilterItemSkeleton,
  Empty,
} from 'components';
import { selectCertification } from 'slice';
import { getDummyArray } from 'utils';

import { DeleteText, SectionData } from './styles';

interface SelectCertificatesStepProps {
  data: any;
  isLoadingCertification: boolean;
  handleClickCertifications: (e: string) => void;
  handleSelectAllOrDeleteCertificates: () => void;
}

const SelectCertificatesStepDesktop = ({
  data,
  isLoadingCertification,
  handleClickCertifications,
  handleSelectAllOrDeleteCertificates,
}: SelectCertificatesStepProps): JSX.Element => {
  const certificationList = useAppSelector(selectCertification);

  return (
    <>
      <Row justifyContent="space-between">
        <Text color="dark" weight="bold">
          Danh sách ({certificationList.list.length}):
        </Text>
        <Row width="fit-content">
          <Text>Bạn đã chọn {data.certificationIDs.length}</Text>
          <Divider type="vertical" />
          <DeleteText onClick={handleSelectAllOrDeleteCertificates}>
            {data.certificationIDs.length > 0 ? 'Xóa tất cả' : 'Chọn tất cả'}
          </DeleteText>
        </Row>
      </Row>
      <Space height={12} />
      {!isLoadingCertification && certificationList.list.length === 0 && (
        <Empty description="Không tìm thấy chứng chỉ" minHeight={120} />
      )}
      <SectionData>
        <AntdRow gutter={[12, 12]}>
          {isLoadingCertification
            ? getDummyArray(12).map(item => (
                <Col span={8}>
                  <CheckFilterItemSkeleton key={item.key} />
                </Col>
              ))
            : certificationList.list.map((item: any, index: number) => (
                <Col
                  span={8}
                  onClick={() => handleClickCertifications(item.id)}
                >
                  <CertificationSelected
                    key={item.id}
                    image={item.logo}
                    selected={data.certificationIDs.includes(item.id)}
                    title={item.name}
                  />
                </Col>
              ))}
        </AntdRow>
      </SectionData>
    </>
  );
};

export default SelectCertificatesStepDesktop;
